/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const customerGroup = queryKey[2];
  const searchTerm = queryKey[3];
  const company = queryKey[4];
  const profileName = queryKey[5];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_all_customers?company=${company}&search_term=${searchTerm}&page_length=10&start=1&customer_group=${customerGroup}&pos_profile=${profileName}`,

      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchCustomers = (customerGroup: string, search: string) => {
  const { url } = useSelector(selectAuth);
  const { data: profile } = useFetchPosProfileDetails();

  return useQuery(
    ['customers', url, customerGroup, search, profile?.company, profile?.name],
    fetcher,
  );
};
